'use strict';

var appDom = require('./app-dom');

var toggle = function(classState) {

	appDom.app.toggleClass('app--is-loading', classState);

};

var addEventHandlers = function() {

	appDom.document.on('image_grid_loaded slideshow_opened', function() {

		toggle(false);

	});

	appDom.document.on('image_grid_loading', function() {

		toggle(true);

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init

};
